import type { HTMLAttributes, ReactNode, TdHTMLAttributes, ThHTMLAttributes } from "react";
import { cn } from "../common/utils";

interface AdminTableProps {
  headers: ReactNode[];
  children: ReactNode;
  emptyMessage?: string;
  loadingMessage?: string;
  loading?: boolean;
  colSpan?: number;
}

export const AdminTable = ({
  headers,
  children,
  emptyMessage,
  loadingMessage = "데이터를 불러오는 중입니다.",
  loading = false,
  colSpan,
}: AdminTableProps) => {
  const span = colSpan ?? headers.length;

  return (
    <div className="overflow-x-auto">
      <table className="w-full min-w-full text-left">
        <thead>
          <tr className="bg-slate-50 border-b border-slate-100">
            {headers.map((header, index) => (
              <AdminTh key={`${String(header)}-${index}`}>{header}</AdminTh>
            ))}
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan={span} className="px-4 py-10 text-center text-xs text-slate-400">
                {loadingMessage}
              </td>
            </tr>
          ) : emptyMessage ? (
            <tr>
              <td colSpan={span} className="px-4 py-10 text-center text-xs text-slate-400">
                {emptyMessage}
              </td>
            </tr>
          ) : (
            children
          )}
        </tbody>
      </table>
    </div>
  );
};

export const AdminTh = ({ className, children, ...props }: ThHTMLAttributes<HTMLTableCellElement>) => {
  return (
    <th className={cn("px-3 py-2.5 text-xs font-semibold text-slate-500 tracking-wide align-top", className)} {...props}>
      {children}
    </th>
  );
};

export const AdminTd = ({ className, children, ...props }: TdHTMLAttributes<HTMLTableCellElement>) => {
  return (
    <td className={cn("min-w-0 px-3 py-2.5 align-top", className)} {...props}>
      {children}
    </td>
  );
};

export const AdminTr = ({ className, children, ...props }: HTMLAttributes<HTMLTableRowElement>) => {
  return (
    <tr className={cn("border-b border-slate-50 transition-colors", className)} {...props}>
      {children}
    </tr>
  );
};
